export interface INurse {
  _id: string;
  refNo: string;
  name: string;
  casualId?: string | null;
  /** When true, admin sync must not rewrite this nurse's casualId. */
  casualIdManual?: boolean;
  email: string;
  age: number;
  contactNo: string;
  password: string;
  active: boolean;
  archived: boolean;
  address: string;
  notes: string;
  profilePic: string;
  gurdianName: string;
  gurdianContact: string;
  rooster: string[];
  rate: number;
  experienceLevel: string[] | number;
  registrationDate: Date;
  registrationNo: string;
  salary: number;
  createdAt: string;
  employmentType?: string;
  permanentConversionStatus?: string;
  epfNumber?: string | null;
  appointmentDate?: Date | null;
  availability?: boolean;
  dateOfBirth?: Date;
}

export const EMPLOYMENT_TYPE = {
  CASUAL: 'Casual',
  PERMANENT: 'Permanent',
} as const;

export const PERMANENT_CONVERSION_STATUS = {
  NONE: 'None',
  ELIGIBLE: 'Eligible',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
} as const;

export const LEAVE_TYPE = {
  ANNUAL_LEAVE: 'AnnualLeave',
  DAY_OFF: 'DayOff',
} as const;

/** Display employee number: Casual ID before permanence, EPF after. */
export function getEmployeeNumber(nurse: Partial<INurse> | null | undefined): string {
  if (!nurse) return 'Unavailable';
  if (nurse.employmentType === EMPLOYMENT_TYPE.PERMANENT && nurse.epfNumber) {
    return nurse.epfNumber;
  }
  if (nurse.casualId) return nurse.casualId;
  return nurse.refNo || 'Unavailable';
}
